import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import BgImg from "../../../images/case-studies/peanut/banner-back.webp";

function Banner() {
  return (
    <section
      className="banner_parcheesi banner_peanut text_white"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="banner_logo">
              <StaticImage
                src="../../../images/case-studies/peanut/logo.webp"
                alt="TekRevol"
                className="logo_amj"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={250}
                height={180}
              />
            </div>
            <p>
              Peanut Butter Park is the ultimate app for dog owners in the
              United States! We designed this app to help dog owners connect
              with other pet parents, find local resources, and receive
              real-time safety alerts, all in one convenient place. It also
              features an innovative "join park" feature that alerts pet parents
              about nearby dog parks, allowing them to take their furry friends
              on fun playdates. With Peanut Butter Park, dog owners can rest
              assured that they have everything they need to keep their dogs
              happy, healthy, and safe.
            </p>
            <div className="app_btn">
              <Link to="https://apps.apple.com/us/app/peanut-butter-park/id1635347261">
                <StaticImage
                  src="../../../images/case-studies/amj/app_store.webp"
                  alt="TekRevol"
                  className=""
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
